
import router from '@/router';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function handlerAccesNonAuthorise (error:any, redirectToLogout = false):string|null {
  let response = null;
  if (error.status) {
    response = error;
  } else if (error.response && error.response.status) {
    response = error.response;
  }

  if (response) {
    if (response.status === 403 || (response.status === 409 && response.data.code === 'SECURITY_ACCESS_FORBIDDEN')) {
      const cause = (response.status === 403 ? response.data.message : '') || 'ACCES_NON_AUTHORISE';
      if (redirectToLogout) {
        router.push({ name: 'error-logout', query: { cause } });
      }
      return cause;
    }
  }

  return null;
}
